import { CustomHtmlProps } from '../types';

export const cmsHtmlParser = (
  props: CustomHtmlProps,
): { bodyParsed: string; cssParsed: string } => {
  let bodyParsed = '';
  let cssParsed = '';

  try {
    bodyParsed = (props.htmlContent || '')
      .replace(/<style((.|\n|\r)*?)<\/style>/gm, '')
      .replace(/<edi((.|\n|\r)*?)<\/edi((.|\n|\r)*?)>/gm, '')
      .replace(/<meta charset="utf-8" \/>/gm, '')
      .replace(
        /<meta name="viewport" content="width=device-width, initial-scale=1">/gm,
        '',
      )
      .replace(/<\/meta>/gm, '')
      .replace(/<center>/gm, '')
      .replace(/<\/center>/gm, '')
      .replace(/ & /gm, ' &amp; ')
      .replace(/'/gm, '&rsquo;')
      .replace(/ 100=""/gm, '')
      .replace(/<br>/gm, '<br />')
      .replace(/<\/br>/gm, '<br />')
      .replace(
        /<a(.*?)(target="_blank")((.|\n|\r)*?)<\/a>/gm,
        '<a$1$2 rel="noreferrer"$3</a>',
      )
      .replace(/<!--((.|\n|\r)*?)-->/gm, '');

    if (process.env.NODE_ENV === 'production') {
      bodyParsed = bodyParsed
        .replace(/class=/gm, 'className=')
        .replace(/srcset=/gm, 'srcSet=');

      const bodyStyleMatch = bodyParsed.match(/ style="([^.]+?)"/gm);

      const bodyStyle =
        (!!bodyStyleMatch &&
          bodyStyleMatch.reduce(
            (previous: Record<string, unknown>, current: string) => ({
              ...previous,
              [current]: current
                .replace(/ style="([^.]+?)"/gm, '$1')
                .split(';')
                .reduce(
                  (ruleMap: Record<string, unknown>, ruleString: string) => {
                    if (!ruleString) return ruleMap;

                    const rulePair = ruleString.split(':');
                    const key = rulePair[0]
                      .trim()
                      .replace(/-([a-z])/g, (g) => g[1].toUpperCase());

                    return {
                      ...ruleMap,
                      [key]: rulePair[1].trim(),
                    };
                  },
                  {},
                ),
            }),
            {},
          )) ||
        {};

      Object.keys(bodyStyle).forEach((key) => {
        bodyParsed = bodyParsed.replace(
          new RegExp(key, 'g'),
          ` style={${JSON.stringify(bodyStyle[key])}}`,
        );
      });
    }

    const cssMatch = (props.htmlContent || '')
      .replace(/<style>/gm, '<style type="text/css">')
      .match(/<style.+>((.|\n|\r)*?)<\/style>/gm);

    if (cssMatch)
      cssParsed = cssMatch
        .map((style: string) =>
          style
            .replace(/<style((.|\n|\r)*?)>/gm, '')
            .replace(/<\/style>/gm, ''),
        )
        .join('')
        .replace(/url\((?!"|')(.+)(?!"|')\)/gm, `url('$1')`);
  } catch (error) {
    console.error('error', error);
  }

  return { bodyParsed, cssParsed };
};
